import styled from 'styled-components';

import { ClosingIndicator } from '@xing-com/closing-indicator';
import { zIndexElevatedLayer4 } from '@xing-com/layout-tokens';
import {
  cornerRadiusXL,
  dropShadowM,
  scale005,
  scale010,
  spaceXL,
  spaceXXS,
  xdlColorBackground,
  xdlColorFocusRing,
  xdlColorModalBorder,
} from '@xing-com/tokens';

// *** Components ***
export const Wrapper = styled.div`
  background: ${xdlColorBackground};
  border-color: ${xdlColorModalBorder};
  border-radius: ${cornerRadiusXL};
  border-style: solid;
  border-width: ${scale005};
  box-shadow: ${dropShadowM};
  padding-bottom: ${spaceXL};
  padding-left: ${spaceXL};
  padding-right: ${spaceXL};
  padding-top: ${spaceXL};
  position: absolute;
  z-index: ${zIndexElevatedLayer4};

  &:focus {
    outline: ${scale010} solid ${xdlColorFocusRing};
    outline-offset: ${spaceXXS};
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:focus-visible {
    outline: ${scale010} solid ${xdlColorFocusRing};
    outline-offset: ${spaceXXS};
  }
`;

export const CloseButton = styled(ClosingIndicator)`
  inset-block-start: 0;
  inset-inline-end: 0;
  position: absolute;
  z-index: 1;
`;
